<template>
  <div class="login">
    <div class="login__image text-center">
      <img :src="image" />
    </div>

    <div class="login__content">
      <div class="login__container">
        <h1 class="login__title">
          <IconLetsSites width="200px" />
        </h1>

        <SignIn
          v-if="flow === 'signin'"
          @handleFlow="changeFlow"
        />
        <RequestPassword
          v-if="flow === 'request'"
          @handleFlow="changeFlow"
        />
        <ResetPassword
          v-if="flow === 'reset'"
          @handleFlow="changeFlow"
        />
      </div>

      <footer class="login__footer">
        <div class="links">
          <a
            href="mailto:suporteplataformas@pmweb.com.br"
            target="_blank"
          >
            Suporte
          </a>
          <a
            href="https://suportehotels.pmweb.com.br/pt/"
            target="_blank"
          >
            Lets Conhecimento
          </a>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import IconLetsSites from '@/components/icons/IconLetsSites.vue';
import SignIn from './SignIn.vue';
import ResetPassword from './ResetPassword.vue';
import RequestPassword from './RequestPassword.vue';

const loginImage = require('@/assets/login-lets.png');

export default {
  name: 'Login',
  components: {
    SignIn,
    ResetPassword,
    RequestPassword,
    IconLetsSites,
  },
  data() {
    return {
      image: loginImage,
      flow: 'signin',
    };
  },
  mounted() {
    const { flow } = this.$route.query;

    if (flow === 'reset' || flow === 'first-access') {
      this.flow = 'reset';
    }
  },
  methods: {
    changeFlow(flow) {
      this.flow = flow;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  height: 100vh;

  &__image {
    width: 50%;
    background: #fff;

    img {
      height: 100%;

      object-fit: cover;
    }
  }

  &__content {
    width: 50%;

    display: flex;
    flex-direction: column;

    position: relative;
    background-color: #fff;
  }

  &__container {
    max-width: 420px;
    width: 100%;
    margin: auto;
    padding: 0 24px;
  }

  &__title {
    display: flex;
    margin-bottom: 32px;

    .text {
      font-size: 24px;
      font-weight: $lb-light;
      color: #000;
      letter-spacing: 5px;
      text-transform: uppercase;
      margin: 16px 0 0 14px;
    }
  }

  // SignIn, RequestPassword, ResetPassword
  &::v-deep {
    .sign-in,
    .reset-password,
    .request-password {
      &__field {
        position: relative;
        margin-top: 24px;

        label {
          font-size: $size-small;
          font-weight: $lb-medium;
          color: $gray-70;
          margin-bottom: 4px;
          padding-left: 16px;
        }

        input {
          width: 100%;
          height: 42px;

          background-color: $gray-10;
          border: 1px solid $gray-40;
          border-radius: 8px;
          padding-left: 16px;

          color: $gray-100;
          font-size: $size-normal;
          font-weight: $lb-medium;

          &:disabled {
            background-color: $gray-20;
            color: $gray-70;
            cursor: not-allowed;
          }
        }

        .show-password {
          position: absolute;
          right: 12px;
          bottom: 9px;
          color: #757575;
        }

        &--error {
          input {
            border: 1px solid $danger;
            border-radius: 8px;
            color: $danger;
          }
        }

        &--warning {
          position: absolute;
          left: 16px;

          color: $danger;
          font-size: $size-smaller;
          font-weight: $lb-medium;
        }

        &:first-child {
          margin-top: 0;
        }
      }

      &__cta {
        width: 100%;
        height: 48px;

        font-size: $size-normal;
        font-weight: $lb-medium;
        color: #fff;

        background: $primary;
        border-radius: 8px;
        transition: 0.4s;

        margin-top: 16px;

        &:not([disabled]):hover {
          background: $primary-140;
        }

        &--disabled {
          background: $gray-50;
          cursor: not-allowed;
        }

        &--loading span {
          position: relative;

          &::before {
            content: '';
            width: 19px;
            position: absolute;
            right: -20px;
            text-align: start;
            animation: three-dots 1s linear infinite alternate;
          }
        }

        &--no-margin {
          margin: 0;
        }
      }

      &__return,
      &__recovery {
        margin-top: 24px;
        text-align: center;

        button {
          font-size: 16px;
          font-weight: $lb-medium;
          color: $primary;
          transition: 0.4s;

          &:hover {
            color: $primary-140;
          }
        }
      }

      // transition
      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.2s;
      }
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }
    }
  }

  &__footer {
    width: 100%;
    height: 50px;

    background: inherit;

    .links {
      height: 100%;

      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 45px;

      a {
        font-size: $size-normal;
        font-weight: $lb-medium;
        color: $primary;
        transition: 0.4s;

        & + a {
          margin-left: 40px;
        }

        &:hover {
          color: $primary-140;
        }
      }
    }
  }

  // @MEDIAS
  @include media-breakpoint-down(lg) {
    &__image {
      display: none;
    }

    &__content {
      width: 100%;
    }
  }

  // @ANIMATIONS
  @keyframes three-dots {
    25% {
      content: '.';
    }
    50% {
      content: '..';
    }
    100% {
      content: '...';
    }
  }
}
</style>
